/**
 * Yvine Design — services modal.
 * Cached asset, initialised once per [data-art="services"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 *
 * Deep links: #<handle> in the URL opens that card's modal (collection cards
 * and the homepage carousel link to /pages/services#<handle>); opening a card
 * writes #<handle> (replaceState, so Back still leaves the page), closing
 * clears it. Cards without a modal just scroll into view as plain anchors.
 */
Art.section('services', function (root) {
    var section = root;
    var modal = section.querySelector('[data-services-modal]');
    if (!modal) return;
    // Move the modal to <body> so no transformed/filtered ancestor can trap
    // its position:fixed (keeps it centered and full-viewport).
    // A modal hoisted by a previous page (in-place swap) is stale: drop it first.
    document.querySelectorAll('body > .art-smodal').forEach(function (old) { if (old !== modal) old.remove(); });
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var target = modal.querySelector('[data-modal-target]');
    var scroller = modal.querySelector('.art-smodal__scroll');
    var loader = modal.querySelector('[data-art-loader]');
    var loaderTimer = null;
    var lastFocused = null;

    /* The pictures in a service card live in a <template>, so nothing fetches
       them until the card is opened and the template is cloned. Hovering the
       card warms the hero (data-art-warm, art-transitions.js), and on a warm
       open the picture is already there — but a cold one, straight off a tap,
       has a gap. The site mark covers it.

       Held back 250ms on purpose: a loader that blinks on every open is worse
       than none, and a warmed hero never reaches the timer. */
    function hideLoader() {
      window.clearTimeout(loaderTimer);
      if (loader) loader.hidden = true;
    }
    function armLoader() {
      if (!loader) return;
      var hero = target && target.querySelector('img');
      if (!hero || (hero.complete && hero.naturalWidth > 0)) { hideLoader(); return; }
      window.clearTimeout(loaderTimer);
      loaderTimer = window.setTimeout(function () { loader.hidden = false; }, 250);
      hero.addEventListener('load', hideLoader, { once: true });
      hero.addEventListener('error', hideLoader, { once: true });
    }

    function setHash(hash) {
      try { history.replaceState(history.state, '', location.pathname + location.search + (hash ? '#' + hash : '')); } catch (err) {}
    }
    function open(uid, handle) {
      var tpl = section.querySelector('template[data-modal-content="' + uid + '"]');
      if (!tpl || !target) return;
      if (handle && location.hash.slice(1) !== handle) setHash(handle);
      lastFocused = document.activeElement;
      target.innerHTML = '';
      target.appendChild(tpl.content.cloneNode(true));
      // "Get in touch" carries the service, so the contact form opens with a
      // message already naming it (art-contact.js, ?service=).
      var cta = modal.querySelector('.art-smodal__foot-btn');
      if (cta) {
        if (!cta.hasAttribute('data-base-href')) cta.setAttribute('data-base-href', cta.getAttribute('href') || '');
        var base = cta.getAttribute('data-base-href');
        var name = tpl.getAttribute('data-service-title') || '';
        try {
          var u = new URL(base, location.href);
          if (name) u.searchParams.set('service', name); else u.searchParams.delete('service');
          cta.setAttribute('href', u.pathname + u.search + u.hash);
        } catch (err) {}
      }
      armLoader();
      // showModal() opens in the top layer, clear of .page-wrapper's
      // backdrop-filter (which would anchor a fixed overlay to the page, not
      // the viewport). Background goes inert, so no body scroll lock; Escape
      // and focus trapping come from the browser.
      if (!modal.open) modal.showModal();
      if (scroller) scroller.scrollTop = 0;
      var closeBtn = modal.querySelector('.art-smodal__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      hideLoader();
      if (!modal.open) return;
      var card = section.querySelector('[data-modal-handle="' + location.hash.slice(1) + '"]');
      if (card) setHash('');
      modal.close(); // 'close' below does the tidying, however it was dismissed
    }
    modal.addEventListener('close', function () {
      if (target) target.innerHTML = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    });

    section.querySelectorAll('[data-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn.getAttribute('data-modal-open'), btn.getAttribute('data-modal-handle')); });
    });
    // #<handle> → open that card (page load, in-place swap, in-page anchor click)
    function openFromHash() {
      var handle = location.hash.slice(1);
      if (!handle || !section.isConnected) return;
      var btn = null;
      try { btn = section.querySelector('[data-modal-handle="' + handle + '"]'); } catch (err) {}
      if (!btn) return;
      var card = btn.closest('article');
      if (card && card.scrollIntoView) card.scrollIntoView({ block: 'center' });
      open(btn.getAttribute('data-modal-open'), handle);
    }
    openFromHash();
    window.__artServicesHash = openFromHash;
    if (!window.__artServicesHashBound) {
      window.__artServicesHashBound = true;
      window.addEventListener('hashchange', function () { if (window.__artServicesHash) window.__artServicesHash(); });
    }
    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    // Escape is native on <dialog>, but it fires 'cancel' → 'close' without
    // going through close(), so the hash would be left behind.
    modal.addEventListener('cancel', function () {
      var card = section.querySelector('[data-modal-handle="' + location.hash.slice(1) + '"]');
      if (card) setHash('');
    });
    // The panel is the only child that takes clicks, so a click on the dialog
    // element itself is the backdrop.
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    // A link inside the modal (the "Get in touch" footer, a "Learn more"):
    // close first, otherwise the in-place page swap loads the new page UNDER
    // the still-open modal and the tap looks like it did nothing.
    modal.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a[href]')) close();
    });
    // The swap event arrives AFTER the new page's sections are initialised
    // (and a deep link may already have opened a card there), so only a
    // section that left the document closes its modal here.
    document.addEventListener('art:page:swap', function () {
      if (!section.isConnected && modal.open) close();
    });
});
